import React, { useContext } from 'react';

import styled from 'styled-components';

import { AttendanceContext } from '../../context/AttendanceContext';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 6rem;
`;

const NoSessionsAttendanceView: React.FC = () => {
    const { t } = useContext(AttendanceContext);

    return (
        <Container>
            <span>
                <strong>{t('no-dates')}</strong>
            </span>
            <span>{t('please-click-add-new')}</span>
        </Container>
    );
};

export default NoSessionsAttendanceView;
